/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Fact_Start_ValueInputs */

const en_about_fact_start_value = /** @type {(inputs: About_Fact_Start_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The way your business works`)
};

const lv_about_fact_start_value = /** @type {(inputs: About_Fact_Start_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veids, kā strādā Jūsu uzņēmums`)
};

/**
* | output |
* | --- |
* | "The way your business works" |
*
* @param {About_Fact_Start_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_fact_start_value = /** @type {((inputs?: About_Fact_Start_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Fact_Start_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_fact_start_value(inputs)
	return en_about_fact_start_value(inputs)
});